import {
  Box,
  Button,
  Checkbox,
  FormControl,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  // Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SearchAndSelect from "../../../shared/SearchAndSelect";
import { Add, AddPhotoAlternate, Edit } from "@mui/icons-material";
import { useEffect, useState } from "react";
// import axios from "axios";
import { toast } from "react-toastify";
import axiosInstance, { baseUrl } from "../../../config/axios";
import { Radio, Select, Space } from "antd";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #A2A9AE",
  boxShadow: 24,
  p: 0,
  rounded: 2,
};

const ManageProductVariant = ({
  open,
  setOpen,
  searchParamsManage,
  setSearchParamsManage,
  productData,
  colorVarient,
  storeVarient,
  otherVarient,
  searchColor,
  setSearchColor,
  searchStorage,
  setSearchStorage,
  searchOther,
  setSearchOther,
  storeId,
  productId,
  setProductId,
  addvarientData,
  setCategory,
}) => {
  const [checked0, setChecked0] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [dynImage, setDynImage] = useState([]);
  const [dynQuantity, setDynQuantity] = useState("");
  const [dynMrp, setDynMrp] = useState("");
  const [dynPrice, setDynPrice] = useState("");
  const [dynLenght, setDynLenght] = useState("");
  const [dynRating, setDynRating] = useState("");
  const [dynWaight, setDynWaight] = useState("");
  const [dynBreath, setDynBreath] = useState("");
  const [dynHieght, setDynHieght] = useState("");
  const [dynDealProduct, setDynDealProduct] = useState("");
  const [dynRecommend, setDynRecommend] = useState("");
  const [dynStart, setDynStart] = useState("");
  const [dynEnd, setDynEnd] = useState("");
  const [dynamicProductData, setDynaminProductData] = useState([]);
  const [enableEdit, setEnableEdit] = useState({});

  const handleAddMultipla = (event, row) => {
    const reqbody = new FormData();
    reqbody.append("product_variants_id", row.variant_id);
    reqbody.append("store_id", storeId);
    reqbody.append("product", productId || row.product_id);
    reqbody.append(
      "color_variant_value",
      row?.color_value_id ? row?.color_value_id : "",
    );
    reqbody.append(
      "storage_variant_value",
      row?.storage_value_id ? row?.storage_value_id : "",
    );
    reqbody.append(
      "other_variant_value",
      row?.other_value_id ? row?.other_value_id : "",
    );
    reqbody.append("product_variant_name", row?.variant_name);
    reqbody.append("quantity", row.quantity || dynQuantity);

    if (dynImage.length !== 0) {
      for (const file of dynImage?.find((i) => i.id === row.id).dynImage) {
        reqbody.append("variant_image", file);
      }
    } else {
      reqbody.append("variant_image", "");
    }

    reqbody.append("price", row?.price || dynPrice);
    reqbody.append("mrp", row?.mrp || dynMrp);
    reqbody.append("length", row?.length || dynLenght);
    reqbody.append("breadth", row?.breadth || dynBreath);
    reqbody.append("height", row?.height || dynHieght);
    reqbody.append("weight", row?.weight || dynWaight);
    reqbody.append("rating", row?.rating || dynRating);

    if (dynRecommend.length > 0) {
      reqbody.append("recommended", dynRecommend ? "True" : "False");
    } else {
      reqbody.append("recommended", row?.recommended ? "True" : "False");
    }
    if (dynDealProduct.length > 0) {
      reqbody.append("recommended", dynDealProduct ? "True" : "False");
    } else {
      reqbody.append("recommended", row?.deal_start_date ? "True" : "False");
    }

    reqbody.append(
      "deal_start_date",
      "" || row?.deal_start_date?.slice(0, 10) || dynStart,
    );
    reqbody.append(
      "deal_end_date",
      "" || row?.deal_end_date?.slice(0, 10) || dynEnd,
    );

    row.variant_id === ""
      ? axiosInstance
          .post(`api/admin/product-variant-admin-api/`, reqbody, {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          })
          .then((response) => {
            if (response.data.response_code == 200) {
              toast.success(response.data.message);
              setDynQuantity("");
              setDynMrp("");
              setDynPrice("");
              setDynLenght("");
              setDynRating("");
              setDynWaight("");
              setDynBreath("");
              setDynHieght("");
              setDynDealProduct("");
              setDynRecommend("");
              setDynImage([]);
              setDynStart("");
              setDynEnd("");
              setEnableEdit({});
              createCombination();
            } else {
              toast.error(response.data.message);
            }
          })
          .catch((error) => {
            //
          })
      : axiosInstance
          .post(
            `${baseUrl}api/admin/product-variant-update-add-admin/`,
            reqbody,
          )
          .then((response) => {
            toast.success(response.data.message);
            setDynQuantity("");
            setDynMrp("");
            setDynPrice("");
            setDynLenght("");
            setDynRating("");
            setDynWaight("");
            setDynBreath("");
            setDynHieght("");
            setDynDealProduct("");
            setDynRecommend("");
            setDynStart("");
            setDynEnd("");
            setEnableEdit({});
            createCombination();
          })
          .catch((error) => {
            //
          });
  };

  const refreshItemFountData = () => {
    addvarientData();
    setEnableEdit({});
    setDynaminProductData([]);
    handleClose();
  };

  const [type1Value, setType1Value] = useState();
  const [type2Value, setType2Value] = useState();
  const [type3Value, setType3Value] = useState();

  // const onSelectColor = (_, newValue) => {
  //   setCombinationPayload({
  //     ...combinationPayload,
  //     color_value_ids: [newValue.value],
  //   });
  // };
  // const onSelectStorage = (_, newValue) => {
  //   setCombinationPayload({
  //     ...combinationPayload,
  //     storage_value_ids: [newValue.value],
  //   });
  // };
  // const onSelectOther = (_, newValue) => {
  //   setCombinationPayload({
  //     ...combinationPayload,
  //     other_value_ids: [newValue.value],
  //   });
  // };

  const [color_value_ids, setColor_value_ids] = useState([]);
  const [storage_value_ids, setStorage_value_ids] = useState([]);
  const [other_value_ids, setOther_value_ids] = useState([]);

  const handleClose = () => {
    setOpen(false);
    setColor_value_ids([]);
    setStorage_value_ids([]);
    setOther_value_ids([]);
  };

  const [combinationPayload, setCombinationPayload] = useState({
    product_id: "",
  });

  const handleValue1 = (e, id) => {
    if (e.target.checked) {
      color_value_ids.push(id);
      setColor_value_ids(color_value_ids);
    } else {
      setColor_value_ids(color_value_ids.filter((elem) => elem !== id));
    }
  };

  const handleValue2 = (e, id) => {
    if (e.target.checked) {
      storage_value_ids.push(id);
      setStorage_value_ids(storage_value_ids);
    } else {
      setStorage_value_ids(storage_value_ids.filter((elem) => elem !== id));
    }
  };
  const handleValue3 = (e, id) => {
    if (e.target.checked) {
      other_value_ids.push(id);
      setOther_value_ids(other_value_ids);
    } else {
      setOther_value_ids(other_value_ids.filter((elem) => elem !== id));
    }
  };

  const createCombination = () => {
    axiosInstance
      .post(
        // `https://app1.crazzyhub.com/api/admin/create-possible-product-variant-combination-admin/?product_id=${productId}&color_value=${
        //   checked0 ? "True" : "False"
        // }&storage_value=${checked1 ? "True" : "False"}&other_value=${
        //   checked2 ? "True" : "False"
        // }`
        `api/admin/create-possible-product-variant-combination-admin/`,
        {
          ...combinationPayload,
          other_value_ids,
          storage_value_ids,
          color_value_ids,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        if (response.data.response_code === 200) {
          setDynaminProductData(response?.data?.data);
          setDynQuantity("");
          setDynMrp("");
          setDynPrice("");
          setDynLenght("");
          setDynRating("");
          setDynWaight("");
          setDynBreath("");
          setDynHieght("");
          setDynDealProduct("");
          setDynRecommend("");
          setDynStart("");
          setDynEnd("");
          setEnableEdit({});
          setCategory("");
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        //
      });
  };

  const handleDelete = (event, row) => {
    event.preventDefault();
    const delData = window.confirm(
      "Are You Sure Delete Product Variant Combination...!",
    );
    if (delData) {
      axiosInstance
        .delete(`${baseUrl}api/admin/product-variant-delete-admin/`, {
          data: {
            product_variant_ids: [row?.variant_id],
          },
        })
        .then((response) => {
          toast.success(response.data.message);
          setDynQuantity("");
          setDynMrp("");
          setDynPrice("");
          setDynLenght("");
          setDynRating("");
          setDynWaight("");
          setDynBreath("");
          setDynHieght("");
          setDynDealProduct("");
          setDynRecommend("");
          setDynImage([]);
          setDynStart("");
          setDynEnd("");
          setEnableEdit({});
          createCombination();
          setCategory("");
        })
        .catch((error) => {
          //
        });
    }
  };

  const onSelectProduct = (_, newValue) => {
    setCategory(newValue.value2);
    setCombinationPayload({
      product_id: newValue.value,
    });
    // setColor_value_ids([]);
    // setStorage_value_ids([]);
    // setOther_value_ids([]);
  };

  console.log("AAAA", enableEdit);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box sx={{ ...style }} className="rounded-lg !h-[90vh] overflow-auto">
        <div
          className="relative z-30 float-right px-4 text-lg font-bold text-black rounded-sm cursor-pointer bg-slate-200 "
          onClick={refreshItemFountData}
        >
          x
        </div>
        <div className=" !top-0">
          <div className="flex justify-between">
            <div className="!w-[100%] mx-3 gap-x-3">
              <div className="w-[100%] my-3 p-2 rounded flex justify-between shadow-sm shadow-sky-400 !mx-auto">
                <div className="w-[25%]">
                  <div
                    id="child-modal-title "
                    className="!text-black w-[100%] !font-serif font-bold !pb-3  !text-lg"
                  >
                    Manage Product Variant Combination By Product Id
                  </div>
                  <div className="mt-1 font-serif">Select Product :</div>
                  <SearchAndSelect
                    size="small"
                    className="mt-1"
                    textValue={searchParamsManage}
                    setTextValue={setSearchParamsManage}
                    value={productId}
                    setValue={setProductId}
                    onChange={onSelectProduct}
                    options={productData?.map((item) => {
                      return {
                        label: item.title,
                        value: item.id,
                        value2: item.main_category,
                      };
                    })}
                  />
                </div>
                <div className="w-[73%]">
                  <div className="flex justify-between !bg-[#e9e9e9] shadow font-bold p-2 rounded-md">
                    <div className="text-sm">
                      {colorVarient[0]?.variant_name
                        ? colorVarient[0]?.variant_name + " Value"
                        : "Type One"}
                    </div>
                    <div className="text-sm">
                      {storeVarient[0]?.variant_name
                        ? storeVarient[0]?.variant_name + " Value"
                        : "Type Two"}
                    </div>
                    <div className="text-sm">
                      {otherVarient[0]?.variant_name
                        ? otherVarient[0]?.variant_name + " Value"
                        : "Type Three"}
                    </div>
                  </div>
                  <div className=" grid grid-cols-3 gap-2 justify-between  mt-2 !bg-[#f9f9fd] p-1">
                    <FormControl fullWidth className="">
                      <input
                        type="text"
                        value={searchColor}
                        className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                        placeholder="Search Type One"
                        style={{ border: "1px solid black" }}
                        onChange={(event) => setSearchColor(event.target.value)}
                      />
                      <div className="grid grid-cols-2 gap-0 ">
                        {colorVarient &&
                          colorVarient?.map((res, index) => {
                            return (
                              <>
                                <div className="flex">
                                  <div className="h-3 w-3">
                                    <Checkbox
                                      // checked={checked0}
                                      size="small"
                                      onChange={(event) =>
                                        // setChecked0(event.target.checked)
                                        handleValue1(event, res.id)
                                      }
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  </div>
                                  <p className="pt-3 ml-6 text-xs">
                                    {res?.value}
                                  </p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </FormControl>
                    {/* <Select
                      mode="multiple"
                      // size="middle"
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={colorVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    />
                    <Select
                      mode="multiple"
                      // size={size}
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={storeVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    />

                    <Select
                      mode="multiple"
                      // size={size}
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={otherVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    /> */}

                    <FormControl fullWidth>
                      <input
                        type="text"
                        value={searchStorage}
                        className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                        placeholder="Search Type One"
                        style={{ border: "1px solid black" }}
                        onChange={(event) =>
                          setSearchStorage(event.target.value)
                        }
                      />
                      <div className="grid grid-cols-2 gap-0 ">
                        {storeVarient &&
                          storeVarient?.map((res, index) => {
                            return (
                              <>
                                <div className="flex">
                                  <div className="h-3 w-3">
                                    <Checkbox
                                      // checked={checked1}
                                      size="small"
                                      onChange={(event) =>
                                        // setChecked1(event.target.checked)
                                        handleValue2(event, res.id)
                                      }
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  </div>
                                  <p className="pt-3 ml-6 text-xs">
                                    {res.value}
                                  </p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </FormControl>

                    <FormControl fullWidth>
                      <input
                        type="text"
                        value={searchOther}
                        className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                        placeholder="Search Type One"
                        style={{ border: "1px solid black" }}
                        onChange={(event) => setSearchOther(event.target.value)}
                      />
                      <div className="grid grid-cols-2 gap-0 ">
                        {otherVarient &&
                          otherVarient?.map((res, index) => {
                            return (
                              <>
                                <div className="flex">
                                  <div className="h-3 w-3">
                                    <Checkbox
                                      // checked={checked2}
                                      size="small"
                                      onChange={(event) =>
                                        // setChecked2(event.target.checked)
                                        handleValue3(event, res.id)
                                      }
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  </div>
                                  <p className="pt-3 ml-6 text-xs">
                                    {res.value}
                                  </p>
                                </div>
                              </>
                            );
                          })}
                      </div>
                    </FormControl>
                  </div>
                  <div className="flex justify-between mt-1 p-1 text-sm border rounded-md border-slate-500">
                    <div className="mt-1 text-sm">View Combination :</div>
                    <div>
                      <Button
                        variant="contained"
                        className="!bg-sky-500 !text-white"
                        size="small"
                        onClick={createCombination}
                      >
                        View
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="font-bold">
          Total Combination Count :{" "}
          <span className="text-lg font-bold text-green-500">
            {dynamicProductData?.length}
          </span>
        </div>
        <div className="mt-2">
          <TableContainer
            component={Paper}
            sx={{ width: "100%" }}
            className="!text-black !px-[-10px] !h-[49vh] !border !bg-white overflow-auto"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    ID
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-44">Product Variant Name</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-24">Color</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    Storage
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    OTHER
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-28">IAMGE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-24">QUENTITY</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-24">MRP</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    PRICE
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    length
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    breadth
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    height
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    weight
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    rating
                  </TableCell>
                  <TableCell
                    className="!text-center !text-gray-800 !font-bold"
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <div className="w-24">Deal Product</div>
                  </TableCell>
                  <TableCell
                    className="!text-center !text-gray-800 !font-bold"
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    Recommended
                  </TableCell>
                  <TableCell
                    className="!text-center !text-gray-800 !font-bold"
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <div className="w-28">START DATE</div>
                  </TableCell>
                  <TableCell
                    className="!text-center !text-gray-800 !font-bold"
                    style={{
                      borderRight: "1px solid #2E1832",
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    <div className="w-28">END DATE</div>
                  </TableCell>
                  <TableCell
                    style={{
                      borderBottom: "1px solid #2E1832",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    <div className="w-48">ACTION</div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="!bg-red">
                {dynamicProductData &&
                  dynamicProductData?.map((row, index) => (
                    <TableRow key={row.id} className="!text-slate-700">
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row.id ? row.id : index}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.variant_name ? row?.variant_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.color_value_name ? row?.color_value_name : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.storage_value_name
                          ? row?.storage_value_name
                          : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row?.other_value_value ? row?.other_value_value : "--"}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) === Number(index) ? (
                          dynImage?.find((i) => i.id === index)?.dynImage ? (
                            <>
                              <Tooltip arrow placement="top" title="Add Image">
                                <Button component="label">
                                  <input
                                    type="file"
                                    hidden
                                    onChange={(event) => {
                                      setDynImage([
                                        ...dynImage,
                                        {
                                          id: index,
                                          dynImage: event.target.files,
                                        },
                                      ]);
                                    }}
                                  />
                                  <img
                                    src={URL.createObjectURL(
                                      dynImage?.find((i) => i.id === index)
                                        .dynImage?.[0],
                                    )}
                                    className="w-12 h-12"
                                    alt=""
                                  />
                                </Button>
                              </Tooltip>
                            </>
                          ) : (
                            <Button component="label">
                              <input
                                type="file"
                                hidden
                                onChange={(event) => {
                                  setDynImage([
                                    ...dynImage,
                                    {
                                      id: index,
                                      dynImage: event.target.files,
                                    },
                                  ]);
                                }}
                              />
                              <AddPhotoAlternate />
                            </Button>
                          )
                        ) : row?.variant_image?.length ? (
                          <>
                            <img
                              alt=""
                              src={row?.variant_image}
                              className="w-12 h-12 mx-auto"
                            />
                          </>
                        ) : (
                          "--"
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.quantity ? (
                            `${row.quantity}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.quantity}
                            size="small"
                            id="dynPrice"
                            placeholder="Quantity"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) =>
                              setDynQuantity(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.mrp ? (
                            `${row.mrp}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.mrp}
                            size="small"
                            id="dynPrice"
                            placeholder="MRP"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) => setDynMrp(event.target.value)}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.price ? (
                            `₹${row.price}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.price}
                            size="small"
                            id="dynPrice"
                            placeholder="Price"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) =>
                              setDynPrice(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.length ? (
                            `${row.length}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.length}
                            size="small"
                            id="purchase_price"
                            placeholder="Lenght"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) =>
                              setDynLenght(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.breadth ? (
                            `${row.breadth}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.breadth}
                            size="small"
                            placeholder="Breadth"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) =>
                              setDynBreath(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.height ? (
                            `${row.height}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="number"
                            defaultValue={row?.height}
                            size="small"
                            placeholder="Heigth"
                            sx={{ m: 1, minWidth: 80 }}
                            onChange={(event) =>
                              setDynHieght(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.weight ? (
                            `${row.weight}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            sx={{ m: 1, minWidth: 80 }}
                            type="number"
                            defaultValue={row?.weight || ""}
                            size="small"
                            placeholder="Weight"
                            onChange={(event) =>
                              setDynWaight(event.target.value)
                            }
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.rating ? (
                            `${row.rating}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <Select
                                // type="number"
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                defaultValue={row?.rating}
                                onChange={(event) =>
                                  setDynRating(event.target.value)
                                }
                                autoWidth
                                size="small"
                              >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.deal_product ? (
                            `${row?.deal_product}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <Select
                                type="number"
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                defaultValue={
                                  row?.deal_product ? "True" : "False"
                                }
                                onChange={(event) =>
                                  setDynDealProduct(event.target.value)
                                }
                                autoWidth
                                size="small"
                              >
                                <MenuItem value={"True"}>True</MenuItem>
                                <MenuItem value={"False"}>False</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.recommended ? (
                            `${row.recommended}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <>
                            <FormControl sx={{ m: 1, minWidth: 80 }}>
                              <Select
                                type="number"
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                defaultValue={
                                  row?.recommended ? "True" : "False"
                                }
                                onChange={(event) =>
                                  setDynRecommend(event.target.value)
                                }
                                autoWidth
                                size="small"
                              >
                                <MenuItem value={"True"}>True</MenuItem>
                                <MenuItem value={"False"}>False</MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                      </TableCell>

                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.deal_start_date ? (
                            `${row?.deal_start_date?.slice(0, 10)}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="date"
                            defaultValue={
                              row?.deal_start_date?.slice(0, 10) || ""
                            }
                            size="small"
                            id="purchase_price"
                            className="!w-52"
                            onChange={(event) =>
                              setDynStart(event.target.value)
                            }
                          />
                        )}
                      </TableCell>

                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderRight: "1px solid #2E1832",
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {Number(enableEdit?.id) !== Number(index) ? (
                          row?.deal_end_date ? (
                            `${row?.deal_end_date?.slice(0, 10)}`
                          ) : (
                            "--"
                          )
                        ) : (
                          <TextField
                            type="date"
                            defaultValue={
                              row?.deal_end_date?.slice(0, 10) || ""
                            }
                            size="small"
                            id="purchase_price"
                            className="!w-52"
                            onChange={(event) => setDynEnd(event.target.value)}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="!text-center !m-0 !p-0 !text-[12px]"
                        style={{
                          borderBottom: "1px solid #2E1832",
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {row.is_already_added ? (
                          <>
                            <IconButton
                              onClick={(event) => {
                                enableEdit.id === index && enableEdit.isEdit
                                  ? handleAddMultipla(event, row)
                                  : setEnableEdit({
                                      id: row.product_id,
                                      isEdit: true,
                                    });
                              }}
                            >
                              <Edit />
                            </IconButton>
                            <IconButton>
                              <DeleteForeverIcon
                                onClick={(event) => handleDelete(event, row)}
                              />
                            </IconButton>
                          </>
                        ) : (
                          <>
                            <IconButton
                              className=""
                              onClick={(event) => {
                                enableEdit.id === index && enableEdit.isEdit
                                  ? handleAddMultipla(event, row)
                                  : setEnableEdit({
                                      id: index,
                                      isEdit: true,
                                    });
                              }}
                            >
                              <Add />
                            </IconButton>
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Box>
    </Modal>
  );
};

export default ManageProductVariant;
